import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../../../components/Loading';


export default function TextList({ data, loading }) {
    const audioRef = useRef();

    return (
        loading ? <Loading /> : (
            <div className="text-list">
                <audio ref={audioRef} />
                {data?.records?.map((item) => (
                    <Link to={`/DigitalResourceLibrary/${item.channelNo}/${item.id}`} className="item">
                      <div>

   <span className='title'>{item?.title}</span>
                        <span className='name'>演奏者：{item?.extension1}</span>
                      </div>
                     
                        <div className="music">
                            <i
                                className='play'
                            />
                        </div>
                    </Link>
                ))}
            </div>
        )
    );
}